// src/pages/UploadPage.tsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FileUploader from './FileUploader';
import {EntityType} from '../../constants/globalConstants'
import { DocumentFilterDTO ,getEntityDocuments} from './UploadApi';

interface LocationState {
  entityType: string;
  entityId: string;
  metadata?: Record<string, string>;
}

const UploadPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const state = location.state as LocationState;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const tenantId = user?.tenantId || '';  
  const tenantName = user?.tenantName || '';  

  if (!state?.entityType || !state?.entityId) {
    return (
      <div className="p-6 text-red-600 font-semibold">
        Missing required upload parameters. Please go back.
      </div>
    );
  }
   const entityType = state.entityType.toUpperCase() as EntityType;
  const entityId = state.entityId;
  const filterDto : DocumentFilterDTO ={
        tenantId: tenantId, // Replace with actual tenant ID logic
        entityType:entityType,
        entityId:entityId
       
    };

//   const fetchExistingFiles = async (entityType: string, entityId: string) => {
    
//     return [
//       {
//         id: '1',
//         name: 'contract.pdf',
//         uploadedAt: new Date().toISOString(),
//         uploadedBy: 'Firoj',
//         url: 'https://example.com/contract.pdf',
//       },
//     ];
//   };

  return (
    <div className="max-w-4xl mx-auto my-10">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Document Upload</h2>
        <button
          onClick={() => navigate(-1)}
          className="text-blue-600 hover:underline"
        >
          ← Back
        </button>
      </div>

      <FileUploader
        label="Upload your documents"
        entityType={state.entityType}
        entityId={state.entityId}
        bucketName='tadwiro'
        metadata={state.metadata}
       
      />
    </div>
  );
};

export default UploadPage;